exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#rating-inline[data-v-10df7542]{\r\n\tdisplay: inline !important;\r\n    padding: 0;\r\n    width: auto;\n}\n#rating-inline .b-rating-star[data-v-10df7542]{\r\n\tpadding: 0 5px 0 0 !important;\n}\n.spaced-title[data-v-10df7542]{\r\n\tletter-spacing: 0.9px;\n}\r\n", ""]);

// exports
